
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { BookingLink } from '@/types/booking';

interface ProviderInfoPanelProps {
  providerInfo?: BookingLink['providerInfo'];
  providerName: string;
}

const ProviderInfoPanel: React.FC<ProviderInfoPanelProps> = ({ 
  providerInfo, 
  providerName 
}) => {
  return (
    <Card className="p-6 mb-6">
      <div className="flex items-start space-x-4">
        <Avatar className="h-16 w-16">
          {providerInfo?.photoUrl ? (
            <AvatarImage src={providerInfo.photoUrl} alt={providerName} />
          ) : (
            <AvatarFallback className="text-lg">
              {providerName.charAt(0).toUpperCase()}
            </AvatarFallback>
          )}
        </Avatar>
        
        <div className="space-y-2 flex-1">
          <h2 className="text-xl font-bold">{providerName}</h2>
          
          {providerInfo?.category && (
            <div className="inline-block bg-primary/10 text-primary px-2 py-1 rounded-md text-sm font-medium">
              {providerInfo.category}
            </div>
          )}
          
          {providerInfo?.description && (
            <p className="text-muted-foreground mt-2">
              {providerInfo.description}
            </p>
          )}
          
          {providerInfo?.bio && (
            <div className="mt-4 pt-4 border-t border-border">
              <h3 className="text-sm font-medium mb-2">About</h3>
              <p className="text-sm text-muted-foreground">
                {providerInfo.bio}
              </p>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default ProviderInfoPanel;
